import catalog from '../data/bookingCatalog.json';

// Match the city field, never a city name appearing inside a street name.
export function travelQuote(address, service) {
  const junk = catalog.categories.find(group => group.category === 'Junk Removal').items.some(item => item.label === service);
  if (!junk) return { zone: null, fee: 0, pending: false, applies: false };
  const normalized = address.toLowerCase().replace(/\./g, '').trim();
  const parts = normalized.split(',').map(value => value.trim());
  const last = parts[parts.length - 1];
  let city = /^(fl|florida)(?:\s+\d{5}(?:-\d{4})?)?$/.test(last)
    ? parts[parts.length - 2] : last.replace(/\s+(fl|florida)(?:\s+\d{5}(?:-\d{4})?)?$/, '');
  if (parts.length < 2) city = ''; // Full addresses should include a separate city field.
  const match = catalog.travelZones.find(zone => zone.cities.includes(city));
  return { zone: match?.zone ?? null, fee: match?.fee ?? 0, pending: !match, applies: true };
}
